import type { PipeUploadPath } from '../types.js';

export type BulkActionImportUploadPath = `${PipeUploadPath}bulk-imports/${string}`;

export class BulkActionImportUploadPathBuilder {
  public static buildPath(
    accountId: string,
    pipeId: string,
    bulkActionId: string,
  ): `${BulkActionImportUploadPath}` {
    return `accounts/${accountId}/pipes/${pipeId}/bulk-imports/${bulkActionId}`;
  }

  public static isBulkActionImportUploadPath(
    path: string,
  ): path is `${BulkActionImportUploadPath}` {
    const regex = /^accounts\/[^/]+\/pipes\/[^/]+\/bulk-imports\/[^/]+$/;
    return regex.test(path);
  }
}
